export const readyAppPackageLabelKey = (slug) =>
  String(slug || '').toLowerCase() === 'promax' ? 'readyAppsPackageProMax' : 'readyAppsPackagePlus';

export const isDatabaseReadyApp = (kind) =>
  String(kind || '').toLowerCase() === 'database';
